var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticStyle:{"max-width":"15em"},attrs:{"items":_vm.trackingUnits,"outlined":"","dense":_vm.dense,"hide-details":"auto","rules":_vm.rules},model:{value:(_vm.trackingUnit),callback:function ($$v) {_vm.trackingUnit=$$v},expression:"trackingUnit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }